import apiClient from './apiClient';

const BASE = '/notificaciones/preferencias';

// Lista los tipos de notificación configurables para el usuario actual (ya filtrados por lo
// que le corresponde por rol) con su estado habilitado/deshabilitado.
const listar = () => apiClient.get(BASE);

const actualizar = (tipo, habilitado) => apiClient.put(`${BASE}/${tipo}`, { habilitado });

export default { listar, actualizar };
